module.exports = __webpack_public_path__ + "img/CPQ-Image.788a9219.png";